import React, { Component } from "react";
import { connect } from "react-redux";
import Loading from "../../Loading";
import ProductQuantity from "./ProductQuantity";
import ProductPrice from "./ProductPrice";
import Quantity from "../Quantity";

class ProductName extends Component {
  getAddedQuantity = (ignoreMaxQuantity = false) => {
    const editedProduct = this.props.location.state?.editedProduct;
    let addedQuantity = 0;
    if (this.props.product) {
      if (!ignoreMaxQuantity && !this.props.product.max_addable_quantity)
        return 0;
      this.props.cart.forEach((product) => {
        if (product.id === this.props.product.id)
          addedQuantity += product.quantity;
      });
    }
    return addedQuantity - (editedProduct?.quantity || 0);
  };

  render() {
    if (!this.props.product) return <Loading />;
    const { product, language, settings } = this.props;

    // let addedQuantity = this.getAddedQuantity();
    return (
      <div
        className="border-top border-bottom "
        style={{
          backgroundColor: "white",
          lineHeight: "30px",
          minHeight: "45px",
        }}
      >
        <div style={{ marginTop: 5 }}>
          <span
            className={"text-muted cut-text-one-line-product-name ".concat(
              language == "english" ? " mx-3 text-left" : " text-right"
            )}
            style={{
              direction: language == "arabic" ? "rtl" : "ltr",
              width: "97%",
              fontWeight: "bold",
            }}
          >
            {language == "english"
              ? product.product.name
              : product.product.ar_name}
          </span>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: -7,
            flexDirection: language === "arabic" && "row-reverse",
          }}
        >
          <div>
            <ProductPrice />
          </div>
          <div>
            {this.props.store.settings.quantity_box_location ===
            "bottom" ? null : (
              <Quantity
                id={this.props.product.product.id}
                minimumOrderQuantity={this.props.product.minimum_order_quantity}
                maximumOrderQuantity={this.props.product.maximum_order_quantity}
                increments={this.props.product.increments}
                SetQuantity={(quantity) => this.props.SetQuantity(quantity)}
                productQuantity={this.props.productQuantity}
                product={this.props.product.product}
                fromPage="details"
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    settings: state.store.store.settings,
    store: state.store.store,
    cart: state.cart,
    product: state.b2b.selectedProduct,
  };
};

export default connect(mapStateToProps)(ProductName);
